module.exports = __webpack_public_path__ + "img/access.2487b5fe.svg";